import { formatCurrency } from ".";

export const formatCapitalContribution = (value) => formatCurrency(value, { fixed: 0 });
